import { Routes } from '@angular/router';

// Layouts
import {
  CondensedComponent,
  BlankComponent,
  CorporateLayout,
  SimplyWhiteLayout,
  ExecutiveLayout,
  CasualLayout,
  BlankCasualComponent,
  BlankCorporateComponent,
  BlankSimplywhiteComponent
} from './@hornbillfx/layouts';

// Admin themes
import { AdminLayoutComponent } from './@hornbillfx/layouts/admin-layout/admin-layout.component';

// Users themes
import { UsersLayoutComponent } from './@hornbillfx/layouts/users-layout/users-layout.component';
import { RouterModule } from '@angular/router';
// Admin

// Users
import { LoginComponent } from './login/login.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserChangePasswordComponent } from './user-change-password/user-change-password.component';
import { NgModule } from '@angular/core';
import { UserSetPasswordComponent } from './user-set-password/user-set-password.component';
import { UserForgetPassowrdComponent } from './user-forget-passowrd/user-forget-passowrd.component';
import { AuthGuard } from './user-module/auth-guard';
import { IslogedInService } from './services/isloged-in.service';
import { TestCandidateComponent } from './test-candidate/test-candidate.component';
import { LoginAkkuComponent } from './login-akku/login-akku.component';
import { BcmLoginComponent } from './bcm-login/bcm-login.component';
import { ViewTestResultsComponent } from './view-test-results/view-test-results.component';

export const AppRoutes: Routes = [

  // Login UI redirect
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'loginAkku',
    component: LoginAkkuComponent,
    // canActivate:[IslogedInService]
  },
  {
    path: 'bcmLogin',
    component: BcmLoginComponent,
    // canActivate:[IslogedInService]
  },
  // Login
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [IslogedInService]
  },
  {
    path: 'login/:code',
    component: LoginComponent
  },

  {
    path: 'admin',
    component: AdminLayoutComponent,
    loadChildren: './feature-modules/admin/admin.module#AdminModule'
  },

  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [{
      path: 'profile',
      loadChildren: './feature-modules/admin/admin.module#AdminModule'
    }]
  },

  // user forgetPassword
  {
    path: 'forgotPassword',
    component: UserForgetPassowrdComponent
  },
  // user SetPassword

  {
    path: 'setPassword',
    component: UserSetPasswordComponent
  },

  {
    path: 'view-result',
    component: ViewTestResultsComponent
  },
  // {
  //   path: 'testCandidate',
  //   component: TestCandidateComponent
  // },

  // user module routing components
  {
    path: 'user',
    component: UsersLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: 'app/user-module/user-dashboard/user-dashboard.module#UserDashboardModule'
      },
      {
        path: 'courses',
        loadChildren: './user-module/user.module#UserModule'
      },
      {
        path: 'profile',
        component: UserProfileComponent
      },
      {
        path: 'changePassword',
        component: UserChangePasswordComponent
      },
      {
        path: 'dashboard',
        loadChildren: 'app/user-module/user-dashboard/user-dashboard.module#UserDashboardModule'
      },
      {
        path: 'course',
        loadChildren: 'app/user-module/user-course/user-course.module#UserCourseModule'
      },
    ]
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutes, { useHash: true })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/app.routing.ts